import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { LinearProgress, Typography } from '@mui/material';

import { useSettings } from 'app/main/components';
import { DetailsSectionWrapper } from 'app/main/components/page-layouts';

interface OrdersDetailsSectionMinValueProps {
	orderTotValueTaxExcl?: number;
}

export default function OrdersDetailsSectionMinValue({ orderTotValueTaxExcl = 0 }: OrdersDetailsSectionMinValueProps) {
	const { sysSettings, t } = useSettings();

	const minOrderValue = sysSettings.b2b_min_order_value || 0;
	const progress = (orderTotValueTaxExcl * 100) / minOrderValue;

	return (
		<DetailsSectionWrapper
			title={
				<FormattedMessage
					id="ordersDetailsSectionMinValue.title"
					defaultMessage={t('ORDERS_MIN_VALUE_SECTION_TITLE')}
					values={{ value: <FormattedNumber value={minOrderValue} style="currency" currency="EUR" /> }}
				/>
			}
		>
			<Typography className="px-8 text-end" variant="subtitle2">
				<FormattedMessage
					id="ordersDetailsSectionMinValue.progress"
					defaultMessage={t('ORDERS_MIN_VALUE_SECTION_PROGRESS')}
					values={{
						value: (
							<FormattedNumber
								value={minOrderValue - orderTotValueTaxExcl}
								style="currency"
								currency="EUR"
							/>
						)
					}}
				/>
			</Typography>
			<LinearProgress variant="determinate" value={progress > 100 ? 100 : progress} />
		</DetailsSectionWrapper>
	);
}
